<div *ngIf="bookingStore.subscriptionsDetailsLoaded$ | async; else loader" class="checkout-wrapper">
  <div class="back-btn-wrapper">
    <button
      mat-stroked-button
      gtm="onSelect"
      gtmAction="Booking Stepper"
      gtmCategory="booking"
      color="primary"
      (click)="onBack()"
      data-at-back-button
    >
      {{ 'GENERAL.BUTTON.BACK' | translate }}
    </button>
  </div>
  <div class="checkout-content">
    <div class="checkout-list-wrapper">
      <div class="checkout-list">
        <div class="checkout-header-wrapper">
          <h3 class="checkout-list-header">
            {{ '+BOOKING.CHECKOUT.PRO_LIST_DESCRIPTION' | translate }}
          </h3>
        </div>

        <app-booking-devices-list *ngIf="bookingStore.selectedDevices$ | async as selectedDevices">
          <div
            class="checkout-list-entry"
            installation-item
            data-at-installation
            *ngFor="let device of selectedDevices; let i = index"
            id="installation-{{ device.installationId }}"
          >
            <span class="entry-index">{{ i + 1 }}.</span>
            <span
              ><span class="entry-name">{{ bookingService.getDeviceTitle(device) }}</span
              ><span class="entry-address">{{ device.location }}</span
              ><span data-at-boiler-id class="entry-serial">{{ device.vin }}</span></span
            >
          </div>
        </app-booking-devices-list>
      </div>
    </div>
    <div class="checkout-summary-wrapper">
      <div class="summary-transfer">
        <h3 class="summary-title">{{ '+BOOKING.CHECKOUT.PAYMENT_METHOD' | translate }}</h3>
        <div class="summary-transfer-content">
          <p>{{ '+BOOKING.CHECKOUT.PAYMENT_DETAILS' | translate }}</p>
        </div>
      </div>
      <app-booking-contingent-subscriptions-summary
        data-at-checkout-section
        (continue)="onContinue()"
        [anyInstallationSelected]="true"
        [isCheckout]="true"
      ></app-booking-contingent-subscriptions-summary>
    </div>
  </div>
</div>

<ng-template #loader>
  <vi-loader data-at-loader-booking [isLoading]="true"></vi-loader>
</ng-template>
